import { value as value_5, toArray, bind, map, defaultArg } from "../fable_modules/fable-library-js.4.19.3/Option.js";
import { Permission, isAllowed } from "../RAWMap.Models/Security.js";
import { Option, content } from "../fable_modules/Fulma.3.0.0/Elements/Content.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { head, tail, isEmpty, tryFind, empty as empty_1, sortDescending, ofArray, singleton as singleton_1 } from "../fable_modules/fable-library-js.4.19.3/List.js";
import * as react from "react";
import { Optic_Get, Optic_Get_op_HatDot_21762A61 } from "../fable_modules/Fable.Aether.1.0.2/Aether.fs.js";
import { PatientViewModel_get_note_, PatientViewModel_get_createdByUserName_, PatientViewModel_get_id_ } from "../RAWMap.Models/View/Patient.js";
import { InstitutionViewModel_get_name_ } from "../RAWMap.Models/View/Institution.js";
import { DOMAttr, HTMLAttr } from "../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { Controls_multiVerticalTileColumnFlex, Controls_singleVerticalTileColumnFlex, Controls_dropdownButton, Controls_buttonDropdownText, Controls_itemList, Controls_ExpandableText_render } from "../Common/General.js";
import { equals, compare, int32ToString } from "../fable_modules/fable-library-js.4.19.3/Util.js";
import { StudyViewModelModule_status_, StudyViewModelModule_studyCreationDate_, StudyViewModelModule_studyNumber_ } from "../RAWMap.Models/View/Study.js";
import { Common_Treatment, Common_YesNo, Common_StudyStatus_get_display, DateTimeOffset_yyyyMMdd } from "../RAWMap.Models/Common.js";
import { Msg } from "./StudyTypes.js";
import { button, Option as Option_1 } from "../fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { Option as Option_2 } from "../fable_modules/Fulma.3.0.0/Components/Dropdown.fs.js";
import { EditMode } from "../Patient/PatientTypes.js";
import { content as content_1, Header_icon, Header_title, header, card } from "../fable_modules/Fulma.3.0.0/Components/Card.fs.js";
import { card as card_1 } from "./CoreForm/CoreFormView.js";
import { card as card_2 } from "./AnalysisForm/AnalysisFormView.js";
import { Common_GenericOption, Modifier_IModifier, Color_IColor } from "../fable_modules/Fulma.3.0.0/Common.fs.js";
import { view as view_1 } from "./CustomReport/CustomReportView.js";
import { view as view_2 } from "./CustomStentReport/CustomStentReportView.js";
import { Helpers_nothing } from "../fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { view as view_3 } from "../Visualization/VisualizationView.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { approveSegmentationCardOption, helpToolTipsCardOption, staticNotesCard, allMeasurementsCards as allMeasurementsCards_1 } from "../Visualization/VisualizationTemp/VisualizationTempView.js";
import { wrapLocalMsg } from "../Common/InboundOutbound.js";
import { LocalMsg } from "../Visualization/VisualizationTypes.js";
import { LocalMsg as LocalMsg_1 } from "../Visualization/VisualizationTemp/VisualizationTempTypes.js";
import { container } from "../fable_modules/Fulma.3.0.0/Layouts/Container.fs.js";
import { printf, toText } from "../fable_modules/fable-library-js.4.19.3/String.js";

export function coreIsBeingModified(model) {
    return defaultArg(map((core) => {
        const matchValue = core.Mode;
        switch (matchValue.tag) {
            case 1:
            case 2:
                return true;
            default:
                return false;
        }
    }, model.CoreFormComponent), false);
}

export function analysisIsBeingModified(model) {
    return defaultArg(map((ma) => {
        const matchValue = ma.Mode;
        switch (matchValue.tag) {
            case 1:
            case 2:
                return true;
            default:
                return false;
        }
    }, model.AnalysisFormComponent), false);
}

export function coreStudyIsBeingDownloaded(model) {
    return defaultArg(map((core) => {
        if (core.Mode.tag === 4) {
            return true;
        }
        else {
            return false;
        }
    }, model.CoreFormComponent), false);
}

export function disableButton(model, perm) {
    let user;
    let e_3;
    let e_1;
    const matchValue = model.MaybeCurrentUser;
    let matchResult, user_1;
    if (matchValue != null) {
        if ((user = matchValue, isAllowed(perm)(user.roles))) {
            matchResult = 0;
            user_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            e_1 = false;
            break;
        }
        default:
            e_1 = true;
    }
    e_3 = (coreIsBeingModified(model) || e_1);
    return analysisIsBeingModified(model) || e_3;
}

export function patientDetails(patient, institution, maybePostEvar, _dispatch) {
    const arrangeContent = (htmlProps, tag, value) => {
        let children_2;
        return content(singleton_1(new Option(2, [toList(delay(() => append(htmlProps, delay(() => singleton(["style", {
            overflowWrap: "anywhere",
        }])))))])), ofArray([(children_2 = [react.createElement("b", {}, `${tag}: `)], react.createElement("p", {}, ...children_2)), value]));
    };
    return toList(delay(() => {
        let arg_2;
        return append(singleton((arg_2 = Optic_Get_op_HatDot_21762A61(new Optic_Get(), PatientViewModel_get_id_())(patient), arrangeContent([], "Internal Patient ID", arg_2))), delay(() => {
            let arg_6;
            return append(singleton((arg_6 = Optic_Get_op_HatDot_21762A61(new Optic_Get(), InstitutionViewModel_get_name_())(institution), arrangeContent([], "Institution", arg_6))), delay(() => {
                let matchValue;
                return append((matchValue = maybePostEvar, (matchValue == null) ? singleton(arrangeContent([], "Post EVAR", "--")) : ((matchValue.tag === 1) ? singleton(arrangeContent([], "Post EVAR", "No")) : singleton(arrangeContent([new HTMLAttr(65, ["post-evar"])], "Post EVAR", "Yes")))), delay(() => {
                    let arg_19;
                    return append(singleton((arg_19 = Optic_Get_op_HatDot_21762A61(new Optic_Get(), PatientViewModel_get_createdByUserName_())(patient), arrangeContent([], "Created By", arg_19))), delay(() => {
                        let arg_23;
                        return singleton((arg_23 = Controls_ExpandableText_render(defaultArg(Optic_Get_op_HatDot_21762A61(new Optic_Get(), PatientViewModel_get_note_())(patient), "(No note)"), 20, Optic_Get_op_HatDot_21762A61(new Optic_Get(), PatientViewModel_get_id_())(patient)), arrangeContent([], "Patient Creation Note", arg_23)));
                    }));
                }));
            }));
        }));
    }));
}

export function existingStudies(currentStudyId, studies, dispatch) {
    let f2_2;
    const children = [Controls_itemList(ofArray([["Study Number", (arg_2) => int32ToString(Optic_Get_op_HatDot_21762A61(new Optic_Get(), StudyViewModelModule_studyNumber_)(arg_2))], ["Created", (arg_4) => DateTimeOffset_yyyyMMdd(Optic_Get_op_HatDot_21762A61(new Optic_Get(), StudyViewModelModule_studyCreationDate_)(arg_4))], ["Status", (f2_2 = Common_StudyStatus_get_display(), (arg_6) => f2_2(Optic_Get_op_HatDot_21762A61(new Optic_Get(), StudyViewModelModule_status_)(arg_6)))]]), (item_1, _arg) => {
        dispatch(new Msg(23, [item_1]));
    }, studies, [], (item) => {
        let matchResult, i_1;
        if (currentStudyId != null) {
            if (currentStudyId === item.studyId) {
                matchResult = 0;
                i_1 = currentStudyId;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return delay(() => singleton(new HTMLAttr(64, ["is-selected"])));
            default: {
                const matchValue = item.status;
                switch (matchValue.tag) {
                    case 0:
                        return delay(() => singleton(new HTMLAttr(64, ["has-background-warning"])));
                    case 1:
                        return delay(() => singleton(new HTMLAttr(64, ["has-background-danger"])));
                    default:
                        return empty();
                }
            }
        }
    }, (list) => sortDescending(list, {
        Compare: compare,
    }))];
    return react.createElement("div", {
        className: "table-container",
    }, ...children);
}

export function existingStudiesSmall(currentStudyId, studies, dispatch) {
    const children = [Controls_itemList(ofArray([["Study Number", (arg_2) => int32ToString(Optic_Get_op_HatDot_21762A61(new Optic_Get(), StudyViewModelModule_studyNumber_)(arg_2))], ["Created", (arg_4) => DateTimeOffset_yyyyMMdd(Optic_Get_op_HatDot_21762A61(new Optic_Get(), StudyViewModelModule_studyCreationDate_)(arg_4))]]), (item_1, _arg) => {
        dispatch(new Msg(23, [item_1]));
    }, studies, [], (item) => {
        let matchResult, i_1;
        if (currentStudyId != null) {
            if (currentStudyId === item.studyId) {
                matchResult = 0;
                i_1 = currentStudyId;
            }
            else {
                matchResult = 1;
            }
        }
        else {
            matchResult = 1;
        }
        switch (matchResult) {
            case 0:
                return delay(() => singleton(new HTMLAttr(64, ["is-selected"])));
            default:
                return empty();
        }
    }, (list) => sortDescending(list, {
        Compare: compare,
    }))];
    return react.createElement("div", {
        className: "table-container",
    }, ...children);
}

export function editView(model, patient, institution, dispatch) {
    let props_2, children_2, props, children;
    const noEditPatientPermission = disableButton(model, new Permission(16, []));
    const creatingCustomReport = (model.CustomReportComponent != null) ? true : (model.CustomStentReportComponent != null);
    let patientInfoCard;
    const cardButton = Controls_buttonDropdownText("Edit Patient")(singleton_1(new Option_1(16, [noEditPatientPermission ? true : creatingCustomReport])))(toList(delay(() => append(singleton(new Option_2(2, [])), delay(() => (!noEditPatientPermission ? singleton(new Option_2(1, [])) : empty()))))))(ofArray([new Controls_dropdownButton(new DOMAttr(40, [(_arg) => {
        dispatch(new Msg(26, [patient, new EditMode(0, [])]));
    }]), "Update Institution Patient ID"), new Controls_dropdownButton(new DOMAttr(40, [(_arg_1) => {
        dispatch(new Msg(26, [patient, new EditMode(1, [])]));
    }]), "Update Patient Name and Date of Birth"), new Controls_dropdownButton(new DOMAttr(40, [(_arg_2) => {
        dispatch(new Msg(26, [patient, new EditMode(2, [])]));
    }]), "Update Creation Note")]));
    patientInfoCard = singleton_1(card(empty_1(), toList(delay(() => append(singleton(header(empty_1(), ofArray([Header_title(empty_1(), singleton_1("Patient Details")), Header_icon(empty_1(), singleton_1(cardButton))]))), delay(() => {
        let _arg_3;
        return singleton(content_1(empty_1(), patientDetails(patient, institution, bind((study_3) => {
            const matchValue = study_3.postTreatTreatmentType;
            if (matchValue != null) {
                if (matchValue.tag === 1) {
                    return new Common_YesNo(0, []);
                }
                else {
                    return new Common_YesNo(1, []);
                }
            }
            else {
                return undefined;
            }
        }, (_arg_3 = tryFind((study) => equals(study.postTreatTreatmentType, new Common_Treatment(1, [])), model.Studies), (_arg_3 == null) ? tryFind((study_2) => (study_2.postTreatTreatmentType != null), model.Studies) : _arg_3)), dispatch)));
    }))))));
    const canEditStudies = disableButton(model, new Permission(13, []));
    const addAnalysis = card(empty_1(), singleton_1(header(empty_1(), singleton_1(Header_icon(empty_1(), singleton_1(button(ofArray([new Option_1(16, [disableButton(model, new Permission(26, []))]), new Option_1(4, []), new Option_1(17, [singleton_1(new DOMAttr(40, [(_arg_4) => {
        dispatch(new Msg(9, []));
    }]))])]), singleton_1("Create Analysis"))))))));
    const isAnalysisBeingModified = (model.AnalysisFormComponent != null) ? ((model.AnalysisFormComponent.Mode.tag === 1) ? false : (!(model.AnalysisFormComponent.Mode.tag === 2))) : true;
    const studyCard = bind((coreModel) => card_1(coreModel, isAnalysisBeingModified, (perm) => disableButton(model, perm), (arg) => {
        dispatch(new Msg(1, [arg]));
    }), model.CoreFormComponent);
    let analysisCard;
    const existingAnalysis = bind((analysisModel) => card_2(analysisModel, (perm_1) => disableButton(model, perm_1), (arg_1) => {
        dispatch(new Msg(4, [arg_1]));
    }), model.AnalysisFormComponent);
    const matchValue_1 = model.CoreFormComponent;
    let matchResult;
    if (existingAnalysis == null) {
        if (matchValue_1 != null) {
            if (matchValue_1.Mode.tag === 3) {
                if (disableButton(model, new Permission(26, []))) {
                    matchResult = 2;
                }
                else if (matchValue_1.SelectedStudy.status.tag === 3) {
                    matchResult = 3;
                }
                else {
                    matchResult = 4;
                }
            }
            else {
                matchResult = 5;
            }
        }
        else {
            matchResult = 5;
        }
    }
    else if (matchValue_1 != null) {
        if (matchValue_1.Mode.tag === 3) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 5;
    }
    switch (matchResult) {
        case 0: {
            analysisCard = existingAnalysis;
            break;
        }
        case 1: {
            analysisCard = undefined;
            break;
        }
        case 2: {
            analysisCard = undefined;
            break;
        }
        case 3: {
            analysisCard = addAnalysis;
            break;
        }
        case 4: {
            analysisCard = undefined;
            break;
        }
        default:
            analysisCard = existingAnalysis;
    }
    let existingStudiesCard;
    const studyGrid = existingStudies(model.StudyGuid, model.Studies, dispatch);
    const cardButton_1 = singleton_1(button(ofArray([new Option_1(4, []), new Option_1(16, [canEditStudies ? true : creatingCustomReport]), new Option_1(17, [singleton_1(new DOMAttr(40, [(_arg_5) => {
        dispatch(new Msg(28, []));
    }]))])]), singleton_1("Create Study")));
    existingStudiesCard = singleton_1(card(empty_1(), ofArray([header(empty_1(), ofArray([Header_title(empty_1(), singleton_1("Existing Studies")), Header_icon(empty_1(), cardButton_1)])), content_1(empty_1(), singleton_1(studyGrid))])));
    let maybeStudyAlertCard;
    const matchValue_3 = model.CustomReportModel;
    let matchResult_1, customReportModel_1;
    if (matchValue_3 != null) {
        if (defaultArg(matchValue_3.maybeLastReportOutdated, false)) {
            matchResult_1 = 0;
            customReportModel_1 = matchValue_3;
        }
        else {
            matchResult_1 = 1;
        }
    }
    else {
        matchResult_1 = 1;
    }
    switch (matchResult_1) {
        case 0: {
            maybeStudyAlertCard = singleton_1(card(empty_1(), singleton_1(content_1(ofArray([new Common_GenericOption(2, [singleton_1(new Modifier_IModifier(0, [new Color_IColor(7, [])]))]), new Common_GenericOption(1, [singleton_1(["style", {
                padding: "0.5rem 1rem",
            }])])]), singleton_1("Data has changed since the last time the custom report was generated")))));
            break;
        }
        default:
            maybeStudyAlertCard = undefined;
    }
    let displayCards;
    const matchValue_9 = model.VisualizationComponent;
    if (matchValue_9 == null) {
        displayCards = toList(delay(() => append(ofArray(toArray(analysisCard)), delay(() => ofArray(toArray(studyCard))))));
    }
    else {
        const visualizationModel = matchValue_9;
        let patternInput_1;
        const matchValue_10 = model.CustomReportComponent;
        const matchValue_11 = model.CustomStentReportComponent;
        const matchValue_12 = model.CustomReportModel;
        let matchResult_2, customReportComponentModel, customReportModel_2, customStentReportComponentModel;
        if (matchValue_10 == null) {
            if (matchValue_11 == null) {
                matchResult_2 = 2;
            }
            else {
                matchResult_2 = 1;
                customStentReportComponentModel = matchValue_11;
            }
        }
        else if (matchValue_12 == null) {
            if (matchValue_11 != null) {
                matchResult_2 = 1;
                customStentReportComponentModel = matchValue_11;
            }
            else {
                matchResult_2 = 2;
            }
        }
        else {
            matchResult_2 = 0;
            customReportComponentModel = matchValue_10;
            customReportModel_2 = matchValue_12;
        }
        switch (matchResult_2) {
            case 0: {
                patternInput_1 = ["none", view_1(customReportModel_2, customReportComponentModel, model.MaybeCurrentUser, (arg_18) => {
                    dispatch(new Msg(13, [arg_18]));
                })];
                break;
            }
            case 1: {
                patternInput_1 = ["none", view_2(model.CustomStentReportModels, customStentReportComponentModel, model.MaybeCurrentUser, (arg_19) => {
                    dispatch(new Msg(14, [arg_19]));
                })];
                break;
            }
            default:
                patternInput_1 = ["block", Helpers_nothing];
        }
        displayCards = ofArray([(props_2 = [["style", {
            display: patternInput_1[0],
        }]], (children_2 = [view_3(visualizationModel, (arg_20) => {
            dispatch(new Msg(12, [arg_20]));
        })], react.createElement("div", keyValueList(props_2, 1), ...children_2))), patternInput_1[1]]);
    }
    let patternInput;
    const rightCards = singleton_1(singleton_1((props = [["style", {}]], (children = toList(delay(() => {
        let matchValue_4;
        return append((matchValue_4 = maybeStudyAlertCard, (matchValue_4 != null) ? matchValue_4 : (empty())), delay(() => displayCards));
    })), react.createElement("div", keyValueList(props, 1), ...children)))));
    const matchValue_5 = model.VisualizationComponent;
    let matchResult_3, visualizationTempModel;
    if (isEmpty(displayCards)) {
        matchResult_3 = 0;
    }
    else if (matchValue_5 != null) {
        if (model.CustomReportComponent == null) {
            if (matchValue_5.VisualizationSubcomponentModel.tag === 0) {
                matchResult_3 = 2;
                visualizationTempModel = matchValue_5.VisualizationSubcomponentModel.fields[0];
            }
            else {
                matchResult_3 = 3;
            }
        }
        else {
            matchResult_3 = 1;
        }
    }
    else {
        matchResult_3 = 1;
    }
    switch (matchResult_3) {
        case 0: {
            patternInput = [singleton_1(patientInfoCard), singleton_1(existingStudiesCard)];
            break;
        }
        case 1: {
            patternInput = [ofArray([patientInfoCard, existingStudiesCard]), rightCards];
            break;
        }
        case 2: {
            const allMeasurementsCards = allMeasurementsCards_1(visualizationTempModel, (arg_4) => {
                dispatch(new Msg(12, [wrapLocalMsg(new LocalMsg(9, [arg_4]))]));
            });
            const notesCard = staticNotesCard(visualizationTempModel, (arg_9) => {
                dispatch(new Msg(12, [wrapLocalMsg(new LocalMsg(9, [wrapLocalMsg(new LocalMsg_1(11, [arg_9]))]))]));
            });
            const maybeHelpToolTipsCard = helpToolTipsCardOption(visualizationTempModel, (arg_13) => {
                dispatch(new Msg(12, [wrapLocalMsg(new LocalMsg(9, [wrapLocalMsg(arg_13)]))]));
            });
            const maybeApproveSegmentationCard = approveSegmentationCardOption(visualizationTempModel, (arg_17) => {
                dispatch(new Msg(12, [wrapLocalMsg(new LocalMsg(9, [wrapLocalMsg(arg_17)]))]));
            });
            patternInput = [toList(delay(() => append((maybeHelpToolTipsCard != null) ? singleton(value_5(maybeHelpToolTipsCard)) : empty(), delay(() => append(allMeasurementsCards, delay(() => append(singleton(notesCard), delay(() => ((maybeApproveSegmentationCard != null) ? singleton(value_5(maybeApproveSegmentationCard)) : empty()))))))))), rightCards];
            break;
        }
        default:
            patternInput = [empty_1(), rightCards];
    }
    const rightColumns = patternInput[1];
    const leftColumns = patternInput[0];
    let matchResult_4, col, left, right;
    if (!isEmpty(leftColumns)) {
        if (isEmpty(tail(leftColumns))) {
            if (isEmpty(rightColumns)) {
                matchResult_4 = 0;
                col = head(leftColumns);
            }
            else {
                matchResult_4 = 1;
                left = leftColumns;
                right = rightColumns;
            }
        }
        else {
            matchResult_4 = 1;
            left = leftColumns;
            right = rightColumns;
        }
    }
    else if (!isEmpty(rightColumns)) {
        if (isEmpty(tail(rightColumns))) {
            matchResult_4 = 0;
            col = head(rightColumns);
        }
        else {
            matchResult_4 = 1;
            left = leftColumns;
            right = rightColumns;
        }
    }
    else {
        matchResult_4 = 1;
        left = leftColumns;
        right = rightColumns;
    }
    switch (matchResult_4) {
        case 0:
            return Controls_singleVerticalTileColumnFlex([new HTMLAttr(99, ["study-edit-view"])], singleton_1(col), singleton_1(["style", {
                overflowY: "hidden",
            }]));
        default:
            return Controls_multiVerticalTileColumnFlex([new HTMLAttr(99, ["study-edit-view"])], "380px", "360px", left, singleton_1(["style", {
                maxHeight: "calc(100vh - 102px - 5.5rem)",
                overflowY: "auto",
                overflowX: "visible",
            }]), right, singleton_1(["style", {
                overflowY: "hidden",
            }]));
    }
}

export function view(_pid, model, dispatch) {
    let props_10, children_10, props_12, props_6, props_8, props_2, children_2, props_4;
    if ((model.isStudiesLoading ? true : model.isAnalysisLoading) && (model.CoreFormComponent == null)) {
        const props = [["style", {
            minHeight: "10em",
        }], new HTMLAttr(64, ["spinner is-loading"])];
        return react.createElement("div", keyValueList(props, 1));
    }
    else {
        const matchValue = model.SelectedPatient;
        const matchValue_1 = model.PatientInstitution;
        if (matchValue != null) {
            if (matchValue_1 != null) {
                const institution = matchValue_1;
                const patient = matchValue;
                const matchValue_3 = model.StudyGuid;
                let matchResult, guid;
                if (matchValue_3 != null) {
                    if (model.CoreFormComponent == null) {
                        matchResult = 0;
                        guid = matchValue_3;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0:
                        return container(empty_1(), singleton_1(content(empty_1(), ofArray([(props_10 = [["style", {
                            textAlign: "center",
                        }]], (children_10 = [toText(printf("Study with ID %O not found"))(guid)], react.createElement("p", keyValueList(props_10, 1), ...children_10))), (props_12 = [["style", {
                            textAlign: "center",
                        }]], react.createElement("p", keyValueList(props_12, 1), "Either study does not exist or you lack permission to access it"))]))));
                    default:
                        return editView(model, patient, institution, dispatch);
                }
            }
            else {
                return container(empty_1(), singleton_1(content(empty_1(), ofArray([(props_6 = [["style", {
                    textAlign: "center",
                }]], react.createElement("p", keyValueList(props_6, 1), "Institution not found")), (props_8 = [["style", {
                    textAlign: "center",
                }]], react.createElement("p", keyValueList(props_8, 1), "Either institution does not exist or you lack permission to access it"))]))));
            }
        }
        else {
            return container(empty_1(), singleton_1(content(empty_1(), ofArray([(props_2 = [["style", {
                textAlign: "center",
            }]], (children_2 = [toText(printf("Patient with ID %O not found"))(model.PatientGuid)], react.createElement("p", keyValueList(props_2, 1), ...children_2))), (props_4 = [["style", {
                textAlign: "center",
            }]], react.createElement("p", keyValueList(props_4, 1), "Either patient does not exist or you lack permission to access them"))]))));
        }
    }
}

